// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"b47532a3","321":"89900b86","804":"d8dd5730"}[chunkId] + ".js";
};